import { useEffect, useRef, useState } from 'react'

import Konva from 'konva'
import { Group, Text } from 'react-konva'

interface StackedTextProps {
  topText?: string
  bottomText?: string
  x: number
  y: number
  width: number
  fontSize?: number
}

/**
 * Styles constants
 */
const PADDING = 9

const StackedText = ({ topText = '', bottomText = '', x, y, width, fontSize = 24 }: StackedTextProps) => {
  const text1Ref = useRef<Konva.Text>(null)
  const text2Ref = useRef<Konva.Text>(null)
  const [positions, setPositions] = useState({ text1Y: 0, text2Y: 0 })

  useEffect(() => {
    const t1 = text1Ref.current
    const t2 = text2Ref.current
    if (!t1 || !t2) return

    const text1Height = t1.height()
    const text1Y = -text1Height - PADDING
    const text2Y = PADDING

    setPositions({ text1Y, text2Y })
  }, [y, topText, bottomText, fontSize])

  return (
    <Group x={x + PADDING} y={y}>
      <Text
        ref={text1Ref}
        text={topText}
        fontSize={fontSize}
        x={0}
        y={positions.text1Y}
        width={width - PADDING * 2}
        verticalAlign="bottom"
      />
      <Text
        ref={text2Ref}
        text={bottomText}
        fontSize={fontSize}
        x={0}
        y={positions.text2Y}
        width={width - PADDING * 2}
      />
    </Group>
  )
}

export default StackedText
